import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  selectInput: {
    minWidth: 250
  }
}));

export default { useStyles };
